import { render, staticRenderFns } from "./AppIndex.vue?vue&type=template&id=eaddcf0c&scoped=true&"
import script from "./AppIndex.vue?vue&type=script&lang=js&"
export * from "./AppIndex.vue?vue&type=script&lang=js&"
import style0 from "./AppIndex.vue?vue&type=style&index=0&id=eaddcf0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaddcf0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VMain,VRow})
